import { useMemo } from 'react';

import { useOperations } from '@frontend/hooks';

// Mirrors PRIVATE_AGENTS_USER_OPERATION in hypatia's app/core/acl.py.
const PRIVATE_AGENTS_USER_OPERATION = 'manage_private_agents' as const;

/**
 * Permissions for the private-agents feature.
 *
 * `canManagePrivateAgents` requires BOTH the Advanced-tier instance capability
 * (`private_agents_enabled`) AND the user op — mirroring the established
 * useToolPermissions / useSpecializedAgentPermissions pattern.
 */
export function usePrivateAgentPermissions() {
  const { canUser, canInstance } = useOperations();

  return useMemo(() => {
    const hasPrivateAgentsCapability = canInstance(['private_agents_enabled']);
    const canManagePrivateAgents =
      hasPrivateAgentsCapability && canUser([PRIVATE_AGENTS_USER_OPERATION]);

    return { hasPrivateAgentsCapability, canManagePrivateAgents };
  }, [canUser, canInstance]);
}
